import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import FormNumberInput from "../../../../Components/FormNumberInput";

const Step2_LoanAmounts = () => {
  const {
    control,
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  const loan_duration = watch("loan_duration");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="duration_to_qualify"
          control={control}
          label={`Duration to qualify (month)`}
          min={0}
          rules={{
            required: "Enter a valid duration to qualify.",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.duration_to_qualify}>
          <InputLabel htmlFor="duration_to_qualify">
            Duration to qualify (month)
          </InputLabel>
          <OutlinedInput
            id="duration_to_qualify"
            type="number"
            {...register("duration_to_qualify")}
            label="Duration to qualify (month)"
            fullWidth
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
          />
          {errors.duration_to_qualify && (
            <FormHelperText>Enter duration to qualify</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="maximum_loan_amount"
          control={control}
          label={`Maximum loan amount`}
          min={0}
          rules={{
            required: "Enter a valid maximum loan amount.",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.maximum_loan_amount}>
          <InputLabel htmlFor="maximum_loan_amount">
            Maximum loan amount
          </InputLabel>
          <OutlinedInput
            id="maximum_loan_amount"
            type="number"
            {...register("maximum_loan_amount")}
            label="Maximum loan amount"
            fullWidth
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
          />
          {errors.maximum_loan_amount && (
            <FormHelperText>Enter maximum loan amount</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="minimum_loan_amount"
          control={control}
          label={`Minimum loan amount`}
          min={0}
          rules={{
            required: "Enter a valid minimum loan amount.",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.minimum_loan_amount}>
          <InputLabel htmlFor="minimum_loan_amount">
            Minimum loan amount
          </InputLabel>
          <OutlinedInput
            id="minimum_loan_amount"
            type="number"
            {...register("minimum_loan_amount")}
            label="Minimum loan amount"
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
            fullWidth
          />
          {errors.minimum_loan_amount && (
            <FormHelperText>Enter minimum loan amount</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="minimum_instalment_count"
          control={control}
          label={`Minimum Installment count per ${loan_duration || "period"}`}
          min={0}
          rules={{
            required: "Enter a valid minimum installment count.",
          }}
        />
        {/* <FormControl fullWidth error={!!errors.minimum_instalment_count}>
          <InputLabel htmlFor="minimum_instalment_count">
            Minimum Installment count per {loan_duration || "period"}
          </InputLabel>
          <OutlinedInput
            id="minimum_instalment_count"
            type="number"
            {...register("minimum_instalment_count")}
            label={`Minimum Installment count per ${loan_duration || "period"}`}
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
            fullWidth
          />
          {errors.minimum_instalment_count && (
            <FormHelperText>Enter minimum installment count!</FormHelperText>
          )}
        </FormControl> */}
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormNumberInput
          name="instalment_counts"
          control={control}
          label={`Maximum Installment count per ${loan_duration || "period"}`}
          min={0}
          rules={{
            required: "Enter a valid maximum installment count.",
          }}
        />

        {/* <FormControl fullWidth error={!!errors.instalment_counts}>
          <InputLabel htmlFor="instalment_counts">
            Maximum Installment count per {loan_duration || "period"}
          </InputLabel>
          <OutlinedInput
            id="instalment_counts"
            type="number"
            {...register("instalment_counts")}
            label={`Maximum Installment count per ${loan_duration || "period"}`}
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
            fullWidth
          />
          {errors.instalment_counts && (
            <FormHelperText>Enter maximum installment count!</FormHelperText>
          )}
        </FormControl> */}
      </Grid>
    </Grid>
  );
};

export default Step2_LoanAmounts;
